import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">极速高清</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              极速高清在线视频平台，提供高清影视、综艺、纪录片等海量内容，支持多端在线观看，无需下载，随时随地畅享高清视频体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/dianying" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">热门电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">最新剧集</Link></li>
              <li><Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-foreground-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <span>contact@jisugaoqing.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                <span>400-888-8888</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>北京市朝阳区望京科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2024 极速高清 Jisugaoqing.com 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}